<script setup lang="ts">
import TextInputComponent from "@/builder/components/textInput/TextInputComponent.vue";

defineProps(["component"]);
</script>

<template>
    <text-input-component :component="component" />
</template>
